import { Component } from '@angular/core';

@Component({
  selector: 'app-pct-events-sidebar-link',
  templateUrl: './pct-events-sidebar-link.component.html',
  styleUrls: ['./pct-events-sidebar-link.component.css']
})
export class PctEventsSidebarLinkComponent {
  data = {
    "id": "eventicancelleria_fascicolo",
    "descrizione": "Eventi Cancelleria",
    "active": false,
    "mandatory": false,
    "grey": false,
    "url": "fascicolo/civile/azionemonitoria/eventicancelleria",
    "urlInserimento": null,
    "descrittori": [
        "SezioneEventiCancelleria"
    ],
    "disabled": false,
    "inserimento": false,
    "hide": false,
    "idPratica": "7532b2d1-cdb1-435a-bb4b-ec801df4405d"
  }
}
